import axios from '@/utils/request'

import { api_onlineOrder } from '@/utils/request'
import config from '@/config'
/** 
  订单管理
**/
// 获取订单概况
export const getOrderGeneral = (params)=>{
  return axios.request({
     url: 'v1/order/order/general',
     method: 'get',
     params
   })
 };
// 获取云店订单列表
export const getOrderList = (params)=>{
 return axios.request({
    url: 'v1/order/order/index',
    method: 'get',
    params
  })
};
// 获取发货管理 - 列表
export const getOrderDeliveryList = (params)=>{
  return axios.request({
    url: 'v1/order/order/deliveryList',
    method: 'get',
    params
  })
};
 // 获取奖品订单 - 订单列表
export const getOrderPrizeList = (params)=>{
  return axios.request({
    url: 'v1/order/prize/index',
    method: 'get',
    params
  })
};
 // 获取积分订单 - 列表
export const getOrderPointList = (params)=>{
  return axios.request({
    url: 'v1/order/point/index',
    method: 'get',
    params
  })
};
// 获取云店订单详情
export const getOrderMore = (params)=>{
  return axios.request({
     url: 'v1/order/order/read',
     method: 'get',
     params
  })
};
 
//订单确认发货
export const orderDelivery = (data)=>{
  return axios.request({
    url: 'v1/order/order/delivery',
    method: 'post',
    data
  })
};
 //订单管理 - 修改订单备注
export const setOrderRemark = (data)=>{
  return axios.request({
    url: 'v1/order/order/storeRemark',
    method: 'post',
    data
  })
};
 // 订单管理 - 订单备注详情
export const getOrderRemark = (params)=>{
  return axios.request({
    url: 'v1/order/order/storeRemarkDetail',
    method: 'GET',
    params
  })
};
//订单管理 - 修改发货
export const orderDeliveryEdit = (data)=>{
  return axios.request({
    url: 'v1/order/order/deliveryEdit',
    method: 'post',
    data
  })
};
//订单管理 - 修改发货详情
export const getorderDeliveryEdit = (params)=>{
  return axios.request({
    url: 'v1/order/order/deliveryEditDetail',
    method: 'GET',
    params
  })
};
//修改收货地址详情
export const orderAddressMore = (params)=>{
  return axios.request({
   url: 'v1/order/order/receiveAddressRead',
   method: 'get',
   params
   })
 };
 //修改收货地址
export const orderAddressEdit = (data)=>{
  return axios.request({
    url: 'v1/order/order/receiveAddress',
    method: 'post',
    data
  })
};
// 下载批量发货模板
export const getDeliveryTemplate = ()=>{
  return axios.request({
    url: 'v1/order/order/deliveryTemplate',
    method: 'get'
  })
};

// 导入发货xlxs
export const setDeliveryTemplate = ()=>{
  return config.baseUrl[process.env.VUE_APP_type]+'v1/order/order/deliveryAll'
};

// 批量发货报表结果
export const getDeliveryTemplateLog = (params)=>{
  return axios.request({
    url: 'v1/order/order/bathchDeliveryLog',
    method: 'get',
    params
  })
};

//订单批量发货
export const orderDeliveryAll = (data)=>{
  return axios.request({
    url: 'v1/order/order/deliveryAll',
    method: 'post',
    data
  })
};

/** 
  退换货管理 
**/
// 获取退换货列表
export const getRefundList = (params)=>{
  return axios.request({
     url: 'v1/order/refund/index',
     method: 'get',
     params
  })
};
// 获取退换货详情
export const getRefundMore = (params)=>{
  return axios.request({
     url: 'v1/order/refund/read',
     method: 'get',
     params
  })
};
//退换货管理 - 退款
export const orderRefundRefund = (data)=>{
  return axios.request({
    url: 'v1/order/refund/refund',
    method: 'post',
    data
  })
};
//退换货管理 - 缺货退款
export const orderNoRefund = (data)=>{
  return axios.request({
    url: 'v1/order/refund/refundForOutOfStock',
    method: 'post',
    data
  })
};

//确认退货退款
export const orderRefundFinal = (data)=>{
  return axios.request({
    url: 'v1/order/refund/final',
    method: 'post',
    data
  })
};

/** 
  退换货地址
**/

// 获取地址列表
export const getAddressList = (params)=>{
  return axios.request({
    url: 'v1/order/address/index',
    method: 'get',
    params
  })
};
// 获取地址详情
export const getAddressMore = (params)=>{
  return axios.request({
    url: 'v1/order/address/read',
    method: 'get',
    params
  })
};
//添加地址
export const setaddressAdd = (data)=>{
  return axios.request({
    url: 'v1/order/address/save',
    method: 'post',
    data
  })
};
//修改地址
export const addressEdit = (data)=>{
  return axios.request({
    url: 'v1/order/address/update',
    method: 'post',
    data
  })
};
//地址删除
export const addressDel = (data)=>{
  return axios.request({
    url: 'v1/order/address/delete',
    method: 'post',
    data
  })
};

/** 
  订单设置
**/

// 订单设置 - 设置详情
export const getOrderSetup = (params)=>{
  return axios.request({
    url: 'v1/setting/read',
    method: 'get',
    params
  })
};
//订单设置 - 设置
export const setOrderSetup = (data)=>{
  return axios.request({
    url: 'v1/setting/trade',
    method: 'post',
    data
  })
};

/** 
  订单统计
**/

// 订单统计 - 数据
export const getOrderStatistics = (params)=>{
  return axios.request({
    url: 'v1/order/statistics/index',
    method: 'get',
    params
  })
};
// 订单统计 -门店数据详情
export const getOrderStatisticsStoreRead = (params)=>{
  return axios.request({
    url: '/v1/order/statistics/storeRead',
    method: 'get',
    params
  })
};
// 订单统计 - 商品数据详情
export const getOrderStatisticsProductRead = (params)=>{
  return axios.request({
    url: '/v1/order/statistics/productRead',
    method: 'get',
    params
  })
};
// 订单统计 - 商品数据详情
export const getOrderStatisticsDealerRead = (params)=>{
  return axios.request({
    url: '/v1/order/statistics/dealerRead',
    method: 'get',
    params
  })
};
// 拼团订单统计 - 数据
export const getOrderStatisticsSharing = (params)=>{
  return axios.request({
    url: 'v1/order/statistics/sharing',
    method: 'get',
    params
  })
};
// 奖品订单统计 - 数据
export const getOrderStatisticsPrize = (params)=>{
  return axios.request({
    url: '/v1/order/statistics/prize',
    method: 'get',
    params
  })
};
// 积分订单统计 - 数据
export const getOrderStatisticsPoint = (params)=>{
  return axios.request({
    url: '/v1/order/statistics/point',
    method: 'get',
    params
  })
};

// 秒杀订单统计 - 数据
export const getOrderStatisticsSeckill = (params)=>{
  return axios.request({
    url: '/v1/order/statistics/seckill',
    method: 'get',
    params
  })
};


/**
 * 
 * 物流公司
 */
//系统物流公司
export const getLibExpressList = (params)=>{
  return axios.request({
    url: 'v1/order/express/libExpressList',
    method: 'get',
    params
  })
};
//物流公司 - 列表
export const getExpressList = (params)=>{
  return axios.request({
    url: 'v1/order/express/index',
    method: 'get',
    params
  })
};
//物流公司 - 详情
export const getExpressMore = (id)=>{
  return axios.request({
    url: 'v1/order/express/read?id='+id,
    method: 'get'
  })
};
//物流公司 - 新增
export const setExpressAdd = (data)=>{
  return axios.request({
    url: 'v1/order/express/save',
    method: 'POST',
    data
  })
};
//物流公司 - 编辑
export const setExpressEdit = (data)=>{
  return axios.request({
    url: 'v1/order/express/update',
    method: 'POST',
    data
  })
};
//物流公司 - 是否显示
export const setExpressState = (data)=>{
  return axios.request({
    url: 'v1/order/express/state',
    method: 'POST',
    data
  })
};
//物流公司 - 刪除
export const setExpressDel = (data)=>{
  return axios.request({
    url: 'v1/order/express/delete',
    method: 'POST',
    data
  })
};

/**
 * 
 * 运费模板
 */

//运费模板 - 模板列表
export const getDeliveryList = (params)=>{
  return axios.request({
    url: 'v1/order/delivery',
    method: 'get',
    params
  })
};
//运费模板 - 模板详情
export const getDeliveryMore = (id)=>{
  return axios.request({
    url: 'v1/order/delivery/'+id,
    method: 'get'
  })
};
//运费模板 - 模板添加
export const setDeliveryAdd = (data)=>{
  return axios.request({
    url: 'v1/order/delivery',
    method: 'POST',
    data
  })
};
//运费模板 - 模板编辑
export const setDeliveryEdit = (data)=>{
  return axios.request({
    url: 'v1/order/updateDelivery',
    method: 'POST',
    data
  })
};
//物流公司 - 刪除
export const setDeliveryDel = (id)=>{
  return axios.request({
    url: 'v1/order/delivery/'+id,
    method: 'DELETE',
  })
};
// 渠道订单   使用该实例

// 订单查询
export const getChannelOrder = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/index',
    method: 'get',
    params
  })
};
// 订单查询-详情
export const getChannelOrderDetail = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/detail',
    method: 'get',
    params
  })
};
// 渠道订单-发货d
export const channelOrderDelivery = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/delivery',
    method: 'POST',
    params
  })
};

// 订单查询-修改备注
export const channelOrderRemarkUpdate = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/remarkUpdate',
    method: 'POST',
    params
  })
};

// 发货管理列表
export const getChannelOrderShip = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/deliveryList',
    method: 'get',
    params
  })
};

// 发货管理-生成导入模板
export const downloadExportModel = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/downloadExportModel',
    method: 'get',
    params
  })
};

// 下载excel文件 api_onlineOrder 当前实例调用 在线订货接口
export const downloadEx = (params)=>{
  return api_onlineOrder.request({
    url: 'download',
    method: 'get',
    params
  })
};
// 上传模板
export const onlineOrderImport = ()=>{
  return config.onlineOrderUrl[process.env.VUE_APP_type]+'online/admin/channelOrder/import'
};



// 售后维权列表
export const getChannelOrderAfterSale = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/afterSale',
    method: 'get',
    params
  })
};

// 售后维权-详情
export const getChannelRefundDetail = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/refundDetail',
    method: 'get',
    params
  })
};

// 售后维权-退款
export const getChannelRefund= (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/refund',
    method: 'post',
    params
  })
};
// 售后维权-发表留言
export const sendChannelRefundMessage = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/message',
    method: 'post',
    params
  })
};
// 售后维权-退货退款审核
export const getChannelRefundAudit = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/refundAudit',
    method: 'post',
    params
  })
};

// 提货码订单查询
export const getChannelOrderPickUpCodeSearch = (params)=>{
  return axios.request({
    url: 'v1/onlineOrder/pickUpCodeSearch',
    method: 'get',
    params
  })
};

// 提货码订单核销
export const getChannelOrderPickUpCodeWriteOff = (data)=>{
  return axios.request({
    url: 'v1/onlineOrder/pickUpCodeWriteOff',
    method: 'post',
    data
  })
};
// 订单物流信息获取
export const getOrderLogistics = (params)=>{
  return axios.request({
    url: 'v1/order/point/logistics',
    method: 'get',
    params
  })
};
// 一件代发订单列表
export const getOrderInsteadShip = (params)=>{
  return axios.request({
    url: 'v1/order/insteadShip',
    method: 'get',
    params
  })
};
// 一件代发订单列表
export const getOrderInsteadShipMore = (id)=>{
  return axios.request({
    url: 'v1/order/insteadShip/'+id,
    method: 'get'
  })
};

//兑换码类礼品
export const getTotal = (params)=>{ 
  return axios.request({
    url: '/v2/order/point/getRedeemCode',
    method: 'get',
    params
  })
};